import React, { useState, useContext } from 'react';
import AuthContext from '../contexts/AuthContext';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export function NavMenu(props) {
    
    let { authenticatedUser } = useContext(AuthContext);

    const [collapsed, setCollapsed] = useState(true);

    function toggleNavbar() {
        setCollapsed(!collapsed);
    }

    
    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                <Container>
                    <NavbarBrand tag={Link} to="/">FreightTracker</NavbarBrand>
                    <NavbarToggler onClick={e => toggleNavbar()} className="mr-2" />
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/">Consignment Lookup</NavLink>
                            </NavItem>
                            {
                                authenticatedUser &&
                                <NavItem>
                                    <NavLink className="text-dark" href="/user/settings">Settings</NavLink>
                                </NavItem>
                            }
                            {
                                !authenticatedUser &&
                                <NavItem>
                                    <NavLink className="text-dark" href="/user/login">Login</NavLink>
                                </NavItem>
                            }
                            {
                                authenticatedUser &&
                                <NavItem>
                                    <NavLink className="text-dark" href="/user/logout">Logout</NavLink>
                                </NavItem>
                            }
                        </ul>
                    </Collapse>
                </Container>
            </Navbar>
        </header>
    );
    
}
